import styles from './Flamingo.module.scss'
import Popup from 'components/common/PopupCTA/PopupCTA'

const Flamingo: React.FunctionComponent = () => {
  return (
    <>
      <section className={styles.top}>
        <div className={styles.imgs}>
          <img className={styles.background} src="/img/LP/flamingo/top-frame.png" alt="" />
          <img className={styles.card} src="/img/LP/flamingo/top-frame-card.png" alt="" />
          <img className={styles.cloud} src="/img/LP/flamingo/top-frame-cloud.png" alt="" />
          <img className={styles.graph} src="/img/LP/flamingo/top-frame-graph.png" alt="" />
          <img className={styles.mail} src="/img/LP/flamingo/top-frame-mail.png" alt="" />
          <img className={styles.message} src="/img/LP/flamingo/top-frame-message.png" alt="" />
          <img className={styles.mobile} src="/img/LP/flamingo/top-frame-mobile.png" alt="" />
        </div>
        <div className={styles.textWrapper}>
          <h1>
            DX推進を加速させる
            <br />
            ウェブシステムの
            <br />
            モダナイゼーション
          </h1>
          <p>
            既存システムの資産を有効活用し、プログラムに手を加えることなく最新のウェブシステムに変換ができるサービスです。
          </p>
          <a
            href="https://aitria.co.jp/contact/"
            target="_blank"
            rel="noopener"
            className={`${styles.button} ${styles.blackButton}`}
          >
            <span>お問い合わせ</span>
          </a>
        </div>
      </section>
      <section className={styles.caseStudy}>
        <ul>
          <li className={styles.item}>
            <img src="/img/LP/flamingo/logo-kokumin.png" alt="" />
          </li>
          <li className={styles.item}>
            <img src="/img/LP/flamingo/logo-sbi.png" alt="" />
          </li>
          <li className={styles.item}>
            <img src="/img/LP/flamingo/logo-nikon.png" alt="" />
          </li>
          <li className={styles.item}>
            <img src="/img/LP/flamingo/logo-tyokyogas.png" alt="" />
          </li>
          <li className={styles.item}>
            <img src="/img/LP/flamingo/logo-canon.png" alt="" />
          </li>
          <li className={styles.item}>
            <img src="/img/LP/flamingo/logo-saga.png" alt="" />
          </li>
          <li className={styles.item}>
            <img src="/img/LP/flamingo/logo-sompo.png" alt="" />
          </li>
          <li className={styles.item}>
            <img src="/img/LP/flamingo/logo-nomura.png" alt="" />
          </li>
          <li className={styles.item}>
            <img src="/img/LP/flamingo/logo-coop.png" alt="" />
          </li>
          <li className={styles.item}>
            <img src="/img/LP/flamingo/logo-mitubishi.png" alt="" />
          </li>
        </ul>
      </section>
      <section className={styles.solutions}>
        <div className={styles.topWrapper}>
          <p className={styles.miniTitle}>Solutions</p>
          <h3>こんな課題を解決します。</h3>
        </div>
        <ul className={styles.solutionslist}>
          <li className={styles.item}>
            <p className={styles.itemTitle}>画面刷新</p>
            <h4>
              システム改修が難しく、
              <br />
              画面の変更ができない
            </h4>
            <span className={`${styles.redBorder} ${styles.textPartition}`}></span>
            <p className={styles.text}>
              複雑なシステム、高い改修費用といった理由からリニューアルをあきらめていませんか？
              <br />
              flamingoなら既存システムに手を加えることなく、最新の画面デザインに変更することが可能です。
            </p>
          </li>
          <li className={styles.item}>
            <p className={styles.itemTitle}>モバイル対応</p>
            <h4>
              イントラシステム
              <br />
              をモバイル対応にしたい
            </h4>
            <span className={`${styles.redBorder} ${styles.textPartition}`}></span>
            <p className={styles.text}>
              社内のイントラシステムが古くなっているが刷新できない。flamingoならイントラネットであっても既存システムのインターフェースだけ刷新し、既存システムのモダナイゼーションが可能です。
            </p>
          </li>
          <li className={styles.item}>
            <p className={styles.itemTitle}>マイクロサービス対応</p>
            <h4>
              既存システムをマイクロ
              <br />
              サービスに対応させたい
            </h4>
            <span className={`${styles.redBorder} ${styles.textPartition}`}></span>
            <p className={styles.text}>
              本サービスを利用すると既存システムと外部のマイクロサービスを統合して画面を生成することができます。その為、既存システムを徐々にマイクロサービス化させることも可能です。
            </p>
          </li>
        </ul>
        <div className={styles.bottomWrapper}>
          <p>ご相談はお気軽にお問い合わせください。</p>
          <a
            href="https://aitria.co.jp/contact/"
            target="_blank"
            rel="noopener"
            className={`${styles.button} ${styles.whiteButton}`}
          >
            <span>お問い合わせ</span>
          </a>
        </div>
      </section>
      <section className={styles.modernization}>
        <div className={styles.blurRedCircle}></div>
        <h2>
          Aitriaの
          <br />
          モダナイゼーションサービスとは
        </h2>
        <p>
          ウェブシステムに専用のJavaScriptタグを追加することで、
          <br className={styles.pcBr} />
          クラウドサーバから配信されるテンプレート(HTML)が反映され、
          <br className={styles.pcBr} />
          画面表示を最適化させることができるサービスです。
        </p>
        <div className={styles.imgWrapper}>
          <img src="/img/LP/flamingo/moda-arch.png" alt="" />
        </div>
      </section>
      <section className={styles.ourFeature}>
        <p className={styles.miniTitle}>
          <span className={`${styles.redBorder} ${styles.titleSide}`}></span>Our Feature
        </p>
        <h3>
          時代に合ったシステムへの変革
          <br />
          新たな価値を生み出す
        </h3>
        <ul className={styles.features}>
          <li className={styles.item}>
            <div className={styles.badge}>
              <img src="/img/LP/flamingo/cloud-service.png" alt="" />
            </div>
            <h4>クラウドサービスで導入が容易</h4>
            <p>
              一切の物理サーバーを持たず、すべてのサービスをクラウド上に構築しています。
              <br />
              導入にあたっては、HTMLにJavaScriptタグを追加するだけで可能となり、面倒なインストールなどは発生しません。
            </p>
          </li>
          <li className={styles.item}>
            <div className={styles.badge}>
              <img src="/img/LP/flamingo/freedom.png" alt="" />
            </div>
            <h4>画面改修の自由度の高さ</h4>
            <p>
              既存システムの画面デザインを自由に変更することが可能です。画面全体・要素といった単位で指定することができ、既存画面の要素を流用した別画面の生成、特定要素のみを削除、あるいは独自要素の追加といった様々な要求に柔軟に対応できます。
            </p>
          </li>
          <li className={styles.item}>
            <div className={styles.badge}>
              <img src="/img/LP/flamingo/security.png" alt="" />
            </div>
            <h4>安心・安全のセキュリティ</h4>
            <p>
              エンタープライズのウェブシステムで求められる高いセキュリティ水準をクリアしております。また、昨今のインターネット上のセキュリティ意識の高まりを受けて、第三者機関による診断とそれに伴うアップデートを定期的に実施しております。
            </p>
          </li>
          <li className={styles.item}>
            <div className={styles.badge}>
              <img src="/img/LP/flamingo/management.png" alt="" />
            </div>
            <h4>運用を支える管理機能</h4>
            <p>
              エンタープライズ向けのシステムは、継続的かつ安定した運用の実現が必要です。ステージング環境の提供、リリース・切り戻し管理、変更履歴・操作ログといった機能により、安心してご利用いただくことができます。
            </p>
          </li>
        </ul>
      </section>
      <section className={styles.step}>
        <div className={styles.topWrapper}>
          <p className={styles.miniTitle}>Step</p>
          <h3>導入までのステップ</h3>
          <p>
            お問い合わせいただいたあとは
            <br />
            以下のようなステップでサービスを導入します
          </p>
        </div>
        <ul className={styles.steps}>
          <li className={styles.item}>
            <span className={styles.number}>01</span>
            <p className={styles.title}>
              <span className={styles.spnumber}>01</span>ヒアリング
            </p>
            <span className={`${styles.redBorder} ${styles.textPartition}`}></span>
            <p className={styles.text}>既存システムの課題やご要望についてお話を伺います。</p>
          </li>
          <li className={styles.item}>
            <span className={styles.number}>02</span>
            <p className={styles.title}>
              <span className={styles.spnumber}>02</span>既存システム調査
            </p>
            <span className={`${styles.redBorder} ${styles.textPartition}`}></span>
            <p className={styles.text}>対象となる各画面の HTML構造や、出しわけ条件などを調査します。</p>
          </li>
          <li className={styles.item}>
            <span className={styles.number}>03</span>
            <p className={styles.title}>
              <span className={styles.spnumber}>03</span>JavaScriptタグ<span className={styles.ibText}>挿入</span>
            </p>
            <span className={`${styles.redBorder} ${styles.textPartition}`}></span>
            <p className={styles.text}>対象となる画面に専用のJavaScriptタグを挿入いただきます。</p>
          </li>
          <li className={styles.item}>
            <span className={styles.number}>04</span>
            <p className={styles.title}>
              <span className={styles.spnumber}>04</span>開発＆テスト
            </p>
            <span className={`${styles.redBorder} ${styles.textPartition}`}></span>
            <p className={styles.text}>弊社にて、画面開発およびテストを実施いたします。</p>
          </li>
          <li className={styles.item}>
            <span className={styles.number}>05</span>
            <p className={styles.title}>
              <span className={styles.spnumber}>05</span>本番反映
            </p>
            <span className={`${styles.redBorder} ${styles.textPartition}`}></span>
            <p className={styles.text}>テスト完了後、リリースを実施いたします。</p>
          </li>
        </ul>
      </section>
      <section className={styles.function}>
        <img src="/img/LP/flamingo/function-image.png" alt="" />
        <div className={styles.textWrapper}>
          <p className={styles.miniTitle}>
            <span className={`${styles.redBorder} ${styles.titleSide}`}></span>Function
          </p>
          <h3>充実した機能</h3>
          <p className={styles.text}>
            flamingoは、大規模システムの運用に必要な機能を網羅しています。実装・プレビュー、サイトリリースなどの具体的な機能は「機能」ページをご覧ください。
          </p>
          <a href="/products/flamingo/functions/" className={`${styles.button} ${styles.blackButton}`}>
            <span>機能を詳しく見る</span>
          </a>
        </div>
      </section>
      <section className={styles.reason}>
        <div className={styles.blurRedCircle}></div>
        <div>
          <div className={styles.textWrapper}>
            <p className={styles.miniTitle}>
              <span className={`${styles.redBorder} ${styles.titleSide}`}></span>Reasons
            </p>
            <h3>
              Aitriaが
              <br />
              選ばれる理由
            </h3>
            <p className={styles.text}>
              Aitriaのモダナイゼーションサービスは、既に8年以上の稼働実績があり、国内随一のモダナイゼーションサービスとして、大手金融機関、大手重工業、大手製造業などのウェブシステムに広く導入されております。
            </p>
          </div>
          <ul className={styles.numberWrapper}>
            <li className={styles.item}>
              <p className={styles.title}>
                <span className={styles.redCircle}></span>導入企業
              </p>
              <p className={styles.result}>200</p>
            </li>
            <li className={styles.item}>
              <p className={styles.title}>
                <span className={styles.redCircle}></span>稼働実績
              </p>
              <p className={styles.result}>
                8<span className={styles.plus}>+</span>
                <span className={styles.year}>year</span>
              </p>
            </li>
            <li className={styles.item}>
              <p className={styles.title}>
                <span className={styles.redCircle}></span>対応コスト
              </p>
              <p className={styles.result}>1/5</p>
            </li>
          </ul>
        </div>
      </section>
      <article>
        <Popup />
      </article>
    </>
  )
}

export default Flamingo
